import aesjs from 'aes-js';

export function aesEncrypt(value) {
    let aesKey = 'HuiZhongYiBiaoV5';
    let key = aesjs.utils.utf8.toBytes(aesKey);
    let textBytes = aesjs.utils.utf8.toBytes(value);
    textBytes = aesjs.padding.pkcs7.pad(textBytes);
    let aesEcb = new aesjs.ModeOfOperation.ecb(key);
    let encryptedBytes = aesEcb.encrypt(textBytes);
    let encryptedHex = aesjs.utils.hex.fromBytes(encryptedBytes);
    return encryptedHex;
}